export enum DeliveryNoteDocumentType {
  Document = 1,
  Link = 2,
}

export enum PdfKind {
  File = 2,
  Url = 0,
  DriverPdf = 3,
}
